export enum DateRangeType {
    Month,
    Quarter,
}
